const header = {
  homepage: 'https://github.com/acsnevesgit',
  title: 'ACSNEVES',
};

const about = {
  name: 'Cláudia',
  role: 'Engineer/Developer',
  description:
    'Engineering background currently working with Software Development.',
  interests: 'Science, Engineering, Programming, Statistics, Psychology',
  hobbies: 'Reading, podcasts, hiking, dancing, animals, volunteering',
  resume: 'https://example.com',
  social: {
    github: 'https://github.com/acsnevesgit',
    linkedin: 'https://linkedin.com/in/acsneves',
    researchgate: 'https://www.researchgate.net/profile/Ana-Claudia-Neves',
    facebook: 'https://www.facebook.com/FB.Clau.Neves',
  },
};

const projects = [
  {
    name: 'TrackId.net',
    description:
      'At Trackid.net, our mission is to provide a comprehensive and user-friendly platform for tracklist management and sharing. We aim to simplify the process of creating and managing tracklists for audiostreams, making it convenient for music enthusiasts, DJs, and event organizers.',
    stack: [
      'TypeScript',
      'React',
      '.NET',
      'PostgreSQL',
      'Docker',
      'Third-party APIs',
    ],
    livePreview: 'https://trackid.net/',
    private: true,
    imgurl: './assets/projects/trackid.png',
    images: [
      {
        title: 'TrackId.net 1/6',
        caption: 'Home page',
        url: 'https://i.postimg.cc/CKxPz038/trackid-home-page.png',
      },
      {
        title: 'TrackId.net 2/6',
        caption: 'Audio Stream page',
        url: 'https://i.postimg.cc/L8CkQ1Wq/trackid-audiostream-page.png',
      },
      {
        title: 'TrackId.net 3/6',
        caption: 'Tracklist Search page',
        url: 'https://i.postimg.cc/wj6FGHTr/trackid-list-page.png',
      },
      {
        title: 'TrackId.net 4/6',
        caption: 'Browse Styles page',
        url: 'https://i.postimg.cc/XNffShh6/trackid-styles-page.png',
      },
      {
        title: 'TrackId.net 5/6',
        caption: 'Submit Request page',
        url: 'https://i.postimg.cc/RZVQTRg5/trackid-request-page.png',
      },
      {
        title: 'TrackId.net 6/6',
        caption: 'Contact Us page',
        url: 'https://i.postimg.cc/85h6GJZm/trackid-contact-page.png',
      },
    ],
  },
  {
    name: 'Meow & Voff Animal Shelter',
    description:
      'A full-stack web application created using the PERN stack. This project was motivated by my passion for animals and the need to bring attention to homeless cats and dogs in shelters by encouraging their adoption. Includes a restrictive admin dashboard to easily manage the shelter DB.',
    stack: [
      'JavaScript',
      'React',
      'Bootstrap',
      'Node.js',
      'Express.js',
      'PostgreSQL',
      'Knex.js',
      'Objection.js',
      'JWT',
      'Stripe.js',
      'EmailJS',
      'Supabase'
    ],
    livePreview: 'https://meowvoff.vercel.app',
    private: true,
    imgurl: './assets/projects/meow-voff.png',
    images: [
      {
        title: 'Meow & Voff Animal Shelter 1/6',
        caption: 'login page',
        url: 'https://i.postimg.cc/fyXwrhx1/login-page.png',
      },
      {
        title: 'Meow & Voff Animal Shelter 2/6',
        caption: 'main page',
        url: 'https://i.postimg.cc/HxthBZKd/landing-page.png',
      },
      {
        title: 'Meow & Voff Animal Shelter 3/6',
        caption: 'support us page',
        url: 'https://i.postimg.cc/4dr5gj0z/support-us.png',
      },
      {
        title: 'Meow & Voff Animal Shelter 4/6',
        caption: 'our cats page',
        url: 'https://i.postimg.cc/jd8Dnys1/our-cats.png',
      },
      {
        title: 'Meow & Voff Animal Shelter 5/6',
        caption: 'online store page',
        url: 'https://i.postimg.cc/L86G5vLg/online-store.png',
      },
      {
        title: 'Meow & Voff Animal Shelter 6/6',
        caption: 'admin DB manager',
        url: 'https://i.postimg.cc/JnBqtHpk/manage-cats.png',
      },
    ],
  },
  {
    name: 'Re@ct-L@b',
    description:
      'A space to learn and practice JavaScript using the React framework. The components and features are build from scratch or with the help of open-source packages and APIs.',
    stack: [
      'JavaScript',
      'React',
      'SCSS',
      'MUI',
      'Redux',
      'I18next',
      'GraphQL',
      'Chart.js',
      'Netlify',
    ],
    sourceCode: 'https://github.com/acsnevesgit/react-lab.git',
    livePreview: 'https://react-lab-ebon.vercel.app/',
    private: false,
    imgurl: './assets/projects/react-lab.png',
    images: [
      {
        title: 'Re@ct-L@b 1/6',
        caption: 'enter page light mode',
        url: 'https://i.postimg.cc/DZz5ry72/landing-page-light.png',
      },
      {
        title: 'Re@ct-L@b 2/6',
        caption: 'enter page dark mode',
        url: 'https://i.postimg.cc/g0sNL6FS/landing-page-dark.png',
      },
      {
        title: 'Re@ct-L@b 3/6',
        caption: 'art display light mode',
        url: 'https://i.postimg.cc/P5zBKJnZ/light-art.png',
      },
      {
        title: 'Re@ct-L@b 4/6',
        caption: 'card payment dark mode',
        url: 'https://i.postimg.cc/hj3spWGV/dark-payment.png',
      },
      {
        title: 'Re@ct-L@b 5/6',
        caption: 'charts light mode',
        url: 'https://i.postimg.cc/XNr63n9S/light-charts.png',
      },
      {
        title: 'Re@ct-L@b 6/6',
        caption: 'avatar selector dark mode',
        url: 'https://i.postimg.cc/QMhfMJPK/dark-selectavatar.png',
      },
    ],
  },
  {
    name: 'My Youtube Video Player',
    description:
      'A full-stack web application created using the PERN stack and Typescript. Any user can search for, select and display videos from YouTube using the YouTube Data API. Additionally, a logged-in user can perform several CRUD operations such as adding or deleting videos from a favorites list.',
    stack: [
      'TypeScript',
      'React',
      'React Testing Library',
      'Jest',
      'YouTube Data API',
      'Netlify',
      'Heroku',
    ],
    sourceCode: 'https://github.com/acsnevesgit/my-youtube-video-player',
    livePreview: 'https://my-youtube-video-player-app.herokuapp.com/',
    private: true,
    imgurl: './assets/projects/my-yt-videoplayer.png',
    images: [
      {
        title: 'My Youtube Video Player 1/5',
        caption: 'main page logged out user',
        url: 'https://i.postimg.cc/NjRv2b0g/landing-page.png',
      },
      {
        title: 'My Youtube Video Player 2/5',
        caption: 'main page logged in user',
        url: 'https://i.postimg.cc/PfFjgPck/favorites-example.png',
      },
      {
        title: 'My Youtube Video Player 3/5',
        caption: 'video search',
        url: 'https://i.postimg.cc/zXbr8qZH/video-search.png',
      },
      {
        title: 'My Youtube Video Player 4/5',
        caption: 'vaccination modal',
        url: 'https://i.postimg.cc/nLZb47sq/vaccination-modal.png',
      },
      {
        title: 'My Youtube Video Player 5/5',
        caption: 'create account',
        url: 'https://i.postimg.cc/sDkR2bs6/create-account.png',
      },
    ],
  },
  {
    name: 'Mix-it-App',
    description:
      'A FE web application for home cooks created with React and Spoonacular API. A user can find the most popular choices of dishes, filter dishes by Cuisine, search for dishes using keywords, find recipes with instructions and ingredients.',
    stack: ['JavaScript', 'React', 'Spoonacular API', 'Styled-Components'],
    sourceCode: 'https://github.com/acsnevesgit/react-restaurant-app',
    private: false,
    imgurl: './assets/projects/mix-it-app.png',
    images: [
      {
        title: 'Mix-it-App 1/3',
        caption: 'main page',
        url: 'https://i.postimg.cc/jdmZYbt5/landing-page.png',
      },
      {
        title: 'Mix-it-App 2/3',
        caption: 'instructions',
        url: 'https://i.postimg.cc/v8P0XnK5/recipe-instructions.png',
      },
      {
        title: 'Mix-it-App 3/3',
        caption: 'ingredients',
        url: 'https://i.postimg.cc/4yFwdCcW/recipe-ingredients.png',
      },
    ],
  },
  {
    name: 'React Firebase-Chat',
    description:
      'A messaging application build with the help of Firebase (BaaS), mainly for user Authentication, file Storage and as a DB. Some of the features are: user login with Google or GitHub authentication, selection of emojis from a list (WIP), uploading of files to send (WIP).',
    stack: ['JavaScript', 'React', 'Firebase', 'MUI'],
    sourceCode: 'https://github.com/acsnevesgit/firebase-chat',
    private: false,
    imgurl: './assets/projects/firebase-chat.png',
    images: [
      {
        title: 'React Firebase-Chat 1/5',
        caption: 'login page',
        url: 'https://i.postimg.cc/tT1CnWnp/landing-page.png',
      },
      {
        title: 'React Firebase-Chat 2/5',
        caption: 'desktop main page',
        url: 'https://i.postimg.cc/pdLdxg29/chat-large-screen.png',
      },
      {
        title: 'React Firebase-Chat 3/5',
        caption: 'mobile main page',
        url: 'https://i.postimg.cc/523thxMd/chat-small-screen.png',
      },
      {
        title: 'React Firebase-Chat 4/5',
        caption: 'emoji',
        url: 'https://i.postimg.cc/k4kMQGW8/emoji-selector.png',
      },
      {
        title: 'React Firebase-Chat 5/5',
        caption: 'upload',
        url: 'https://i.postimg.cc/xdp1dtC6/file-uploader.png',
      },
    ],
  },
  {
    name: 'Countdown Angular App',
    description:
      'A FE web application built using Angular and Typescript. The user can define the name of an event and the date when it takes place. The countdown should always start from the current time and it should display the time remaining to the specified event in the format: Days, Hours(h), Minutes(m), Seconds(s).',
    stack: ['TypeScript', 'Angular'],
    sourceCode: 'https://github.com/acsnevesgit/countdown-angular-app',
    livePreview: 'https://countdown-to-event-app.netlify.app/',
    private: false,
    imgurl: './assets/projects/countdown-desktop.png',
    images: [
      {
        title: 'Countdown Angular App 1/2',
        caption: 'desktop - UK date format',
        url: 'https://i.postimg.cc/JnMKJWYF/countdown-desktop.png',
      },
      {
        title: 'Countdown Angular App 2/2',
        caption: 'mobile - Sweden date format',
        url: 'https://i.postimg.cc/pXpCKCkP/countdown-mobile.png',
      },
    ],
  },
  {
    name: 'Cuppy Coffee Machine Monitor',
    description:
      'A non-interactive web page to help monitor and manage the operations performance of a coffee machine. At the core it shows the current workload as a percentage bar. Additionally, it can display information about issues that could be affecting the workload display and coffee machine performance.',
    stack: ['VanillaJS', 'Docker', 'Golang'],
    sourceCode: 'https://github.com/acsnevesgit/coffee-monitor',
    private: false,
    imgurl: './assets/projects/cuppy-desktop.png',
    images: [
      {
        title: 'Cuppy Coffee Machine Monitor 1/5',
        caption: 'desktop monitoring off',
        url: 'https://i.postimg.cc/MTYqymzh/monitor-disconneted.png',
      },
      {
        title: 'Cuppy Coffee Machine Monitor 2/5',
        caption: 'desktop normal level ',
        url: 'https://i.postimg.cc/brCP5YDg/monitor-desktop-normal.png',
      },
      {
        title: 'Cuppy Coffee Machine Monitor 3/5',
        caption: 'desktop high level ',
        url: 'https://i.postimg.cc/D0yF54Zm/monitor-high.png',
      },
      {
        title: 'Cuppy Coffee Machine Monitor 4/5',
        caption: 'desktop critical level ',
        url: 'https://i.postimg.cc/CMmw57P8/monitor-critical.png',
      },
      {
        title: 'Cuppy Coffee Machine Monitor 5/5',
        caption: 'mobile normal level',
        url: 'https://i.postimg.cc/Y97tGsB6/monitor-mobile-normal.png',
      },
    ],
  },
];

const softSkills = [
  'Accountability',
  'Critical Thinking',
  'Communication',
  'Curiosity',
  'Drive',
  'Flexibility',
  'Honesty',
  'Organization',
  'Problem-Solving',
  'Time Management',
];

const techSkills = [
  'Bootstrap',
  'CSS',
  'HTML',
  'JavaScript',
  'TypeScript',
  'C++',
  'React',
  'Angular',
  'MATLAB',
  'MUI',
  'Node.js',
  'PostgreSQL',
  'MongoDB',
  'Docker',
];

const tools = [
  'Abaqus FEA',
  'AutoCAD',
  'Git',
  'Jira',
  'Slack',
  'Teams',
  'Trello',
];

const contact = {
  email: 'acsneves@outlook.com',
};

export { about, contact, header, projects, softSkills, techSkills, tools };
